<template>
    <div :class="['live', 'flex', { 'flex-row-reverse': !showChat }]">
        <div ref="liveArea" class="live-area" :style="{ left: showChat ? '310px' : 0 }">
            <!-- 视频区 -->
            <div v-show="showVideo" ref="livePlayer" class="live-player" :style="playerPosition">
                <div id="livePlayer"></div>
                <div class="live-player-mask"></div>
            </div>
            <!-- 文档区 -->
            <div v-show="showDoc" id="drawPanel" :style="drawPosition"></div>
            <div
                v-if="showTip"
                class="live-tip flex flex-column flex-item flex-vertical-center flex-center"
            >
                <img class="live-tip-img" src="@images//player/not-play.png" />
                <div v-if="liveStatus === 'prepare' && timeCount > 0" class="live-tip-text">
                    <p class="mt14">上课时间：{{ video.live_start_time | timeFilter }}</p>
                    <p class="mt14">距离上课时间还有</p>
                    <p class="mt14">
                        <span
                            v-for="(hour, index) in hourTimeCount"
                            :key="`h_${index}`"
                            class="time-label"
                            >{{ hour }}</span
                        >
                        <span>:</span>
                        <span
                            v-for="(minute, index) in minuteTimeCount"
                            :key="`m_${index}`"
                            class="time-label"
                            >{{ minute }}</span
                        >
                        <span>:</span>
                        <span
                            v-for="(second, index) in secondTimeCount"
                            :key="`s_${index}`"
                            class="time-label"
                            >{{ second }}</span
                        >
                    </p>
                </div>
                <div v-else class="live-tip-text">{{ tipInfo }}</div>
            </div>
            <div v-if="notice" class="live-notice">
                <span class="live-notice-content">{{ notice }}</span>
            </div>
            <div class="live-controls">
                <div
                    class="live-controls-bar flex flex-item flex-vertical-center"
                    :style="{ transform: `translateY(${showControl ? 0 : 44}px)` }"
                >
                    <!-- <img src="" alt="" class="play-pause tool-icon" /> -->
                    <time class="tool-item">{{ duration }}</time>
                    <div class="flex-item"></div>
                    <img
                        v-if="showVideo && showDoc"
                        :title="`切换到${layout ? '文档' : '视频'}为主显示`"
                        :src="icons.toggle"
                        :alt="`切换到${layout ? '文档' : '视频'}为主显示`"
                        class="layout tool-icon tool-item"
                        @click="toggleLayoutMode"
                    />
                    <img
                        title="全屏"
                        :src="fullscreen ? icons.exitfullscreen : icons.fullscreen"
                        alt="全屏"
                        class="fullscreen tool-icon tool-item"
                        @click="handleSetFullscreen"
                    />
                </div>
            </div>
        </div>
        <aside class="live-aside flex flex-column">
            <!-- 直播简介 -->
            <div class="live-intro">
                <h2 class="live-title">{{ video.name }}</h2>
                <div class="live-text">
                    授课老师：{{ video.teacher_name }} / 科目：【 {{ video.subject_name }} 】
                </div>
                <!-- <div class="live-text">{{ video.show_time_str }}</div> -->
            </div>
            <!-- 第二屏占位 -->
            <div v-if="showDoc && showVideo" ref="secondScreen" class="second-screen"></div>
            <!-- 工具栏 -->
            <el-tabs
                v-model="activeName"
                :class="[
                    'live-tools',
                    'flex',
                    'flex-item',
                    'flex-column',
                    { 'only-resource': !showQuestion }
                ]"
                :stretch="true"
                @tab-click="handleTabClick"
            >
                <el-tab-pane v-if="showQuestion" class="tab-panel" label="提问区" name="question">
                    <problem-area
                        :problemList="problemList"
                        @send="handleSendQuestion"
                    ></problem-area>
                </el-tab-pane>
                <el-tab-pane class="tab-panel" label="资料下载" name="resource">
                    <resource-download :resourceList="resourceList"></resource-download>
                </el-tab-pane>
            </el-tabs>
        </aside>
        <!-- 第一屏占位 -->
        <div ref="firstScreen" class="first-screen flex-item"></div>
        <aside v-if="showChat" class="live-aside flex flex-column">
            <chat-area :messageList="messageList" @send="handleSendChatMsg" />
        </aside>
        <hk-dialog :state="testVisible" title="直播结束">
            <template #content>
                <div>
                    <p class="tip">请完成随堂作业。快来检验下你的学习成果吧～</p>
                    <img src="@images/player/alarm-clock.png" />
                </div>
            </template>
            <template #footer>
                <div class="flex tip-footer flex-between">
                    <hk-button
                        text="稍后再做"
                        :customStyle="analysisButton"
                        @handleClick="testVisible = false"
                    ></hk-button>
                    <hk-button
                        text="去做题"
                        :customStyle="replayButton"
                        @handleClick="handleToTest"
                    ></hk-button>
                </div>
            </template>
        </hk-dialog>
    </div>
</template>

<script>
import { initLiveSDKLoader } from '@plugins/_live';
import moment from '@plugins/_moment';
import notPlayIcon from '@images/player/not-play.png';
import playIcon from '@images/player/play.svg';
import pauseIcon from '@images/player/pause.svg';
import fullscreenIcon from '@images/player/fullscreen.svg';
import exitfullscreenIcon from '@images/player/exitfullscreen.svg';
import listIcon from '@images/player/list.svg';
import toggleIcon from '@images/player/toggle.svg';
import ProblemArea from '@components/live/ProblemArea.vue';
import ResourceDownload from '@components/live/ResourceDownload.vue';
import HkDialog from '@components/HkDialog.vue';
import HkButton from '@components/HkButton.vue';
import ChatArea from './ChatArea.vue';
import { requestFullscreen, exitFullscreen, isFullScreen } from '@helpers/tools';
import { getCCAuth } from '@api/player';

const icons = {
    unauthorized: playIcon,
    play: playIcon,
    pause: pauseIcon,
    fullscreen: fullscreenIcon,
    exitfullscreen: exitfullscreenIcon,
    list: listIcon,
    toggle: toggleIcon
};
export default {
    name: 'Player',
    components: { ProblemArea, ResourceDownload, ChatArea, HkDialog, HkButton },
    filters: {
        timeFilter(val) {
            const end = moment(Date.now()).endOf('day');
            const time = moment(val);
            if (!end.isBefore(time)) {
                return time.format('HH:mm');
            } else {
                return time.format('MM月DD日 HH:mm');
            }
        }
    },
    props: {
        /**
         * 视频信息
         */
        video: Object
    },
    data() {
        return {
            analysisButton: {
                width: '110px',
                color: '#6D33B3',
                border: '1px solid #6D33B3',
                shadowColor: 'transparent',
                background: true,
                startColor: 'transparent',
                endColor: 'transparent'
            },
            replayButton: {
                width: '110px',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#A90FBC',
                endColor: '#CA2AD0'
            },
            testVisible: false,
            /**
             * 直播开始时间
             */
            liveStartTime: '',
            /**
             * 直播持续时间
             */
            liveDuration: -1,
            icons: Object.freeze(icons),
            /**
             * 直播室设置
             */
            roomSetting: {},
            /**
             * type //直播间模板类型  （1:大屏模式 ，2：问答、视频、聊天 ，3：视频、聊天，4：文档、视频。聊天，5：视频、文档、问答、聊天，6：视频、问答
             */
            template: {},
            viewer: {},
            teachers: [],
            activeName: 'question',
            firstScreenPosition: { left: 0, top: 0, width: 0, height: 0 },
            secondScreenPosition: { left: 0, top: 0, width: 0, height: 0 },
            layout: true, // 布局切换；(false: 文档为主; true: 视频为主;)
            /**
             * 问题列表
             */
            problemList: [],
            /**
             * 消息列表
             */
            messageList: [],
            timer: null,
            /**
             * 在线人数
             */
            onlineUserCount: 0,
            /**
             * 是否显示在线人数
             */
            showOnlineUserCount: false,
            /**
             * 直播播放器类型
             */
            liveType: 'h5',
            /**
             * 直播状态  prepare: 准备、play：播放、pause：暂停、terminate：终止（当前项目没有pause暂停）
             */
            liveStatus: 'loading',
            /**
             * 显示控制条
             */
            showControl: true,
            /**
             * 全屏
             */
            fullscreen: false,
            /**
             * 公告信息
             */
            notice: '',
            /**
             * 直播倒计时定时器
             */
            timeCountTimer: null,
            /**
             * 直播倒计时
             */
            timeCount: 0,
            hourTimeCount: [0, 0],
            minuteTimeCount: [0, 0],
            secondTimeCount: [0, 0]
        };
    },
    computed: {
        resourceList() {
            const { video } = this;
            return video.file
                ? [
                      {
                          name: '课程资料',
                          id: video.id
                      }
                  ]
                : [];
        },
        duration() {
            const { liveDuration } = this;
            if (liveDuration === -1) {
                return '00:00:00';
            }
            const duration = moment.duration(liveDuration * 1000);
            const hour = ('0' + duration.hours()).substr(-2);
            const minute = ('0' + duration.minutes()).substr(-2);
            const second = ('0' + duration.seconds()).substr(-2);
            return `${hour}:${minute}:${second}`;
        },
        teacher() {
            const { teachers } = this;
            const teacherNames = [];
            teachers.forEach((item) => {
                teacherNames.push(item.name);
            });
            return teacherNames.join('、');
        },
        showVideo() {
            return true;
        },
        showChat() {
            const { template } = this;
            return [1, 2, 3, 4, 5].includes(template.type);
        },
        showQuestion() {
            const { template } = this;
            return [1, 2, 5, 6].includes(template.type);
        },
        showDoc() {
            const { template } = this;
            return [1, 4, 5].includes(template.type);
        },
        playerPosition() {
            const { layout, firstScreenPosition, secondScreenPosition, showDoc } = this;
            return layout || !showDoc ? firstScreenPosition : secondScreenPosition;
        },
        drawPosition() {
            const { layout, firstScreenPosition, secondScreenPosition } = this;
            return layout ? secondScreenPosition : firstScreenPosition;
        },
        showTip() {
            if (
                this.liveStatus === 'prepare' &&
                this.video.warm_video_id &&
                (this.layout || !this.showDoc)
            ) {
                return false;
            }
            return ['loading', 'terminate', 'prepare', 'unauthorized'].includes(this.liveStatus);
        },
        tipInfo() {
            let tip = '';
            switch (this.liveStatus) {
                case 'loading':
                    tip = '正在加载，请稍后~';
                    break;
                case 'play':
                    tip = '正在直播~';
                    break;
                case 'pause':
                    tip = '暂停直播~';
                    break;
                case 'terminate':
                    tip = '直播已结束~';
                    break;
                case 'unauthorized':
                    tip = '对不起，尚未获取到授权，请刷新重试~';
                    break;
                default:
                    tip = '直播未开始，老师正在赶来的路上哦~';
                    break;
            }
            return tip;
        }
    },
    watch: {
        liveStatus: {
            handler(val, oldVal) {
                this.toggleShowControl(val);
            },
            immediate: true
        },
        showQuestion: {
            handler(val, oldVal) {
                if (val) {
                    this.activeName = 'question';
                } else {
                    this.activeName = 'resource';
                }
            },
            immediate: true
        },
        'template.type'() {
            this.initLayout();
        }
    },
    mounted() {
        this.init();
        this.setTimeCountDown();
    },
    methods: {
        setTimeCountDown() {
            this.setTimeCount();
            this.timeCountTimer = setInterval(() => {
                this.setTimeCount();
            }, 1000);
            this.$once('hook:beforeDestroy', this.clearTimeCountTimer);
        },
        setTimeCount() {
            const end = moment(this.video.live_start_time, 'YYYY-MM-DD HH:mm:ss').toDate();
            let time = end.valueOf() - Date.now();
            time = time < 0 ? 0 : time;
            const duration = moment.duration(time);
            const h = parseInt(duration.asHours(), 10);
            const m = duration.minutes();
            const s = duration.seconds();
            const hourTimeCount = [];
            const minuteTimeCount = [];
            const secondTimeCount = [];
            if (h < 10) {
                hourTimeCount.push(0);
                hourTimeCount.push(h);
            } else {
                hourTimeCount.push(...h.toString().split(''));
            }
            if (m < 10) {
                minuteTimeCount.push(0);
                minuteTimeCount.push(m);
            } else {
                minuteTimeCount.push(...m.toString().split(''));
            }
            if (s < 10) {
                secondTimeCount.push(0);
                secondTimeCount.push(s);
            } else {
                secondTimeCount.push(...s.toString().split(''));
            }
            this.hourTimeCount = hourTimeCount;
            this.minuteTimeCount = minuteTimeCount;
            this.secondTimeCount = secondTimeCount;
            this.timeCount = time / 1000;
        },
        clearTimeCountTimer() {
            if (this.timeCountTimer) {
                clearInterval(this.timeCountTimer);
                this.timeCount = 0;
                this.timeCountTimer = null;
            }
        },
        handleTabClick(tab) {
            this.activeName = tab.name;
        },
        /**
         * 测试
         */
        handleToTest() {
            this.$trackEvent('答题', '开始做题', this.$route.query.scheduleId);
            this.$router.push({
                name: 'Test',
                query: { scheduleId: this.$route.query.scheduleId }
            });
        },
        /**
         * 切换布局模式
         */
        toggleLayoutMode() {
            this.layout = !this.layout;
        },
        /**
         * 切换控制条显示
         */
        toggleShowControl(liveStatus) {
            const showControl = ['terminate', 'pause', 'prepare'].includes(liveStatus);
            // 延迟3s切换
            setTimeout(() => {
                this.showControl = showControl;
            }, 3000);
        },
        /**
         * 设置全屏
         */
        handleSetFullscreen() {
            if (!this.fullscreen) {
                requestFullscreen(this.$refs['liveArea']);
                this.fullscreen = true;
            } else {
                exitFullscreen();
                this.fullscreen = false;
            }
        },
        async init() {
            // this.listenFullscreen();
            await this.initLayout();
            this.listenLayout();
            await this.initDWlive();
            this.$once('hook:beforeDestroy', this.destroyPlayer);
        },
        /**
         * 销毁播放器
         */
        destroyPlayer() {
            if (this.DWLive && this.DWLive.destroy) {
                this.DWLive.destroy();
            }
        },
        /**
         * 屏幕布局变化监听
         */
        listenLayout() {
            window.addEventListener('resize', this.initLayout);
            this.$once('hook:beforeDestroy', () => {
                window.removeEventListener('resize', this.initLayout);
            });
        },
        /**
         * 初始化屏幕布局
         */
        async initLayout() {
            await this.$nextTick();
            let offsetX = 0;
            let offsetY = -60;
            const $secondScreen = this.$refs['secondScreen'];
            if ($secondScreen) {
                offsetX = -310;
            }
            this.firstScreenPosition = this.getPosition(
                this.$refs['firstScreen'],
                offsetX,
                offsetY
            );
            const secondScreenPosition = this.getPosition($secondScreen, offsetX, offsetY);
            this.secondScreenPosition = {
                ...secondScreenPosition,
                width: '310px',
                height: '192px'
            };
        },
        getPosition(dom, offsetX = 0, offsetY = 0) {
            if (!dom) {
                return { left: 0, top: 0, width: 0, height: 0 };
            }
            const { left, top } = dom.getBoundingClientRect();
            return {
                left: left + offsetX + 'px',
                top: top + offsetY + 'px'
            };
        },
        /**
         * 浏览器全屏监听
         */
        listenFullscreen() {
            const listenFullscreen = () => {
                this.fullscreen = isFullScreen();
            };
            window.addEventListener('resize', listenFullscreen);
            this.$once('hook:beforeDestroy', () => {
                window.removeEventListener('resize', listenFullscreen);
            });
        },
        /**
         * 初始化CC直播
         */
        async initDWlive() {
            await this.$nextTick();
            this.liveStatus = 'loading';
            const DWLive = await initLiveSDKLoader();
            if (!this.video.auth) {
                this.liveStatus = 'unauthorized';
                return false;
            }
            if (this.video.status === 0) {
                this.liveStatus = 'terminate';
            } else {
                this.liveStatus = 'prepare';
            }
            const options = await this.getOptions();
            DWLive.init(options);
            this.DWLive = DWLive;
            DWLive.onLoginSuccess = this.handleLoginSuccess;
            DWLive.on_hd_live_live_type = this.handleHdLiveType;
            DWLive.onLiveStart = this.handleLiveStart;
            DWLive.onLiveEnd = this.handleLiveEnd;
            DWLive.onUserCountMessage = this.handleUserCountMessage;
            DWLive.onPublicChatMessage = this.handleReceiveMsg;
            DWLive.onPublicChatLogManage = this.handlePublicChatLogManage;
            DWLive.onPrivateChatMessage = this.handlePrivateChatMessage;
            DWLive.onPrivateAnswer = this.handlePrivateAnswer;
            DWLive.onQuestion = this.handleReceiveQuestion;
            DWLive.onAnswer = this.handleReceiveAnswer;
            DWLive.onInformation = this.handleForbiddenInformation;
            DWLive.onKickOut = this.handleKickOut;
            DWLive.onAnnouncementShow = this.handleAnnouncementShow;
            DWLive.onAnnouncementRelease = this.handleAnnouncementRelease;
            DWLive.onAnnouncementRemove = this.handleAnnouncementRemove;
            DWLive.onLoginError = this.handleLoginError;
            DWLive.onStartRollCall = this.handleStartRollCall;
            DWLive.onStartLottery = this.handleStartLottery;
            DWLive.onWinLottery = this.handleWinLottery;
            DWLive.onStopLottery = this.handleStopLottery;
            DWLive.onStartVote = this.handleStartVote;
            DWLive.onStopVote = this.handleStopVote;
            DWLive.onVoteResult = this.handleVoteResult;
            DWLive.showUserCount = this.handleShowUserCount;
            DWLive.onLiveDesc = this.handleLiveDesc;
            DWLive.onBroadcastMsg = this.handleBroadcastMsg;
            DWLive.onQaPublish = this.handleQaPublic;
            DWLive.onRoomSetting = this.handleRoomSetting;
            DWLive.onQuestionnairePublish = this.handleQuestionnairePublish;
            DWLive.onQuestionnairePublishStop = this.handleQuestionnairePublishStop;
            DWLive.onQuestionnairePublishStatis = this.handleQuestionnairePublishStatis;
            DWLive.onOnlineTeachers = this.handleOnlineTeachers;
            DWLive.onExternalQuestionnairePublish = this.handleExternalQuestionnairePublish;
            DWLive.onPageChange = this.handlePageChange;
            DWLive.onChangeNickname = this.handleChangeNickName;
            DWLive.onLiveTime = this.handleLiveTime;
            DWLive.onSwitchSource = this.handleSwitchSource;
            DWLive.onSwitchVideoDoc = this.handleSwitchVideoDoc;
            DWLive.onSilenceUserChatMessage = this.handleSilenceUserChatMessage;
            DWLive.onPracticePublish = this.handlePracticePublish;
            DWLive.onPracticePublishStop = this.handlePracticePublishStop;
            DWLive.onPracticeClose = this.handlePracticeClose;
            DWLive.onHdLiveStartPunch = this.handleHdLiveStartPunch;
            DWLive.onHdLiveStopPunch = this.handleHdLiveStopPunch;
            DWLive.onBanChat = this.handleBanChat;
            DWLive.onUnBanChat = this.handleUnBanChat;
            DWLive.onBanDeleteChat = this.handleBanDeleteChat;
            DWLive.HDBanChatBroadcastWithData = this.handleHDBanChatBroadcastWithData;
            DWLive.HDUserRemindWithAction = this.handleHDUserRemindWithAction;
            window._onStart = this.handlePCLivStart;
            window.on_cc_live_interaction_accept = this.handleCCLiveInteractionAccept;
            window.on_cc_live_interaction_message = this.handleCCLiveInteractionMessage;
            window.on_cc_live_interaction_chatusers = this.handleCCLiveInteractionChatUsers;
            window.on_cc_live_interaction_disconnect = this.handleCCLiveInteractionDisconnect;
            window.on_cc_swf_loading_completed = this.handleLiveLoadingCompleted;
            window.onSocketConnect = this.handleSocketConnect;
            window.onSocketDisconnect = this.handleSocketDisconnect;
        },
        async getOptions() {
            const { data } = await getCCAuth();
            const options = {
                userid: data.user_id, // 必须参数
                roomid: this.video.room_id, // 必须参数
                viewername: data.name, // 可选
                viewertoken: data.token, // 如果直播间设置为密码验证，必选
                viewercustomua: 'web',
                language: 'zh',
                pcH5Live: true, // 可选
                viewercustominfo: '', // 可选
                fastMode: true // 可选参数，默认为true
            };
            return options;
        },
        /**
         * 当前播放器是h5还是flash播放器
         */
        handleHdLiveType(type) {
            this.liveType = type;
        },
        /**
         * 登录成功回调
         */
        handleLoginSuccess({ live, template, viewer }) {
            this.liveStartTime = live.liveStartTime;
            this.liveDuration = live.liveDuration;
            this.template = template;
            this.viewer = viewer;
            if (live.liveDuration !== -1) {
                this.liveStatus = 'play';
            }
        },
        /**
         * 登录出现错误时的回调
         */
        handleLoginError(e) {
            console.log('登录出现错误时的回调', e);
            this.$store.dispatch('logout', true);
        },
        /**
         * PC端直播播放器加载完成
         */
        handleLiveLoadingCompleted() {
            // this.createTipInfo();
            this.changeCCTipInfo();
        },
        /**
         * 修改CC直播默认提示
         */
        changeCCTipInfo() {
            const $hdTipContainer = $('.hd-tip-container');
            $hdTipContainer.css({
                background: '#2b2b2d'
            });
            // $hdTipContainer.hide();
        },
        /**
         * 自定义播放器提示信息
         */
        createTipInfo() {
            const $hdTipContainer = $('.hd-tip-container');
            $hdTipContainer.html('');
            $hdTipContainer.addClass('flex-column');
            const img = `<img src="${notPlayIcon}" />`;
            const text = `<div>直播未开始，老师正在赶来的路上哦~</div>`;
            const $img = $(img);
            $img.css({
                width: '226px',
                height: '115px',
                objectFit: 'contain'
            });
            const $text = $(text);
            $text.css({
                fontSize: '32px',
                color: '#FFFFFF',
                marginTop: '32px',
                textAlign: 'center'
            });
            $hdTipContainer.append($img);
            $hdTipContainer.append($text);
        },
        /**
         * 直播间布局配置
         */
        handleRoomSetting(setting) {
            this.roomSetting = setting;
        },
        /**
         * 获取讲师列表
         */
        handleOnlineTeachers({ teachers }) {
            this.teachers = teachers;
        },
        /**
         * 布局切换；layout(false: 文档为主; true: 视频为主;)
         */
        handleSwitchVideoDoc(layout) {
            this.layout = layout === 'true';
        },
        /**
         * 发送问题
         */
        handleSendQuestion(question) {
            this.DWLive.sendQuestionMsg(question);
            this.$trackEvent('直播', '提问');
        },
        /**
         * 公开发布问题
         */
        handleQaPublic(e) {
            console.log('发布问题', e);
        },
        /**
         * 收到提问
         */
        handleReceiveQuestion(e) {
            const { action, value } = JSON.parse(e);
            if (action === 'question') {
                const { isPublish, id, userId } = value;
                const isMe = userId === this.viewer.id;
                if ((isPublish === 1 || isMe) && !this.problemList.some((item) => item.id === id)) {
                    this.problemList.push({ ...value, isMe });
                }
            }
        },
        /**
         * 收到回答
         */
        handleReceiveAnswer(e) {
            const { action, value } = JSON.parse(e);
            if (action === 'answer') {
                const { questionId } = value;
                const question = this.problemList.find((item) => item.id === questionId);
                if (question) {
                    const answers = question.answers || [];
                    answers.push(value);
                    this.$set(question, 'answers', answers);
                }
            }
        },
        /**
         * 发送公聊信息
         */
        handleSendChatMsg(msg) {
            this.DWLive.sendPublicChatMsg(msg);
        },
        /**
         * 收到公聊信息
         */
        handleReceiveMsg(e) {
            const message = JSON.parse(e);
            if (!this.messageList.some((item) => item.chatId === message.chatId)) {
                this.messageList.push({
                    ...message,
                    isMe: message.userid === this.viewer.id
                });
            }
        },
        /**
         * 收到聊天审核消息
         */
        handlePublicChatLogManage(e) {
            console.log('收到聊天审核消息', e);
        },
        /**
         * 直播间禁止聊天或问答时，发送消息的回调通知
         */
        handleForbiddenInformation(msg) {
            this.$message.error(msg);
        },
        /**
         * 用户禁言后发送聊天的消息回调; data:禁言时发送信息回调数据
         */
        handleSilenceUserChatMessage(data) {
            if (data.userid === this.viewer.id) {
                this.$message.error('您已被禁言');
            }
        },
        /**
         * 开始推流直播
         */
        handleLiveStart() {
            console.log('开始推流直播');
            if (!this.timer) {
                setTimeout(() => {
                    this.DWLive.showControl(false);
                }, 1000);
                this.setTimer();
            }
            // 设置直播状态
            this.liveStatus = 'play';
        },
        /**
         * PC端直播中的回调
         */
        handlePCLivStart() {
            console.log('PC端直播中的回调');
            if (!this.timer) {
                setTimeout(() => {
                    this.DWLive.showControl(false);
                }, 1000);
                this.setTimer();
            }
            // 设置直播状态
            this.liveStatus = 'play';
        },
        /**
         * moblie端直播中的回调
         */
        handleMoblieLivStart() {
            console.log('moblie端直播中的回调');
            if (!this.timer) {
                this.setTimer();
            }
            // 设置直播状态
            this.liveStatus = 'play';
        },
        /**
         * 停止推流直播
         */
        handleLiveEnd() {
            console.log('停止推流直播');
            this.clearTimer();
            // 设置直播状态
            this.liveStatus = 'terminate';
            const { video } = this;
            if (video.work_id) {
                this.testVisible = true;
            }
        },
        /**
         * 设置持续时间定时器
         */
        setTimer() {
            if (this.liveDuration < 0) {
                this.liveDuration = 0;
            }
            this.timer = setInterval(() => {
                this.liveDuration += 1;
            }, 1000);
            this.$once('hook:beforeDestroy', this.clearTimer);
        },
        /**
         * 持续时间定时器清除
         */
        clearTimer() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        /**
         * '获取开始直播时间和直播时间（未开始直播返回 {liveStartTime: "", liveDuration: -1}）'
         */
        handleLiveTime({ liveStartTime, liveDuration }) {
            this.liveStartTime = liveStartTime;
            this.liveDuration = liveDuration;
        },
        /**
         * 踢出
         */
        handleKickOut(data) {
            const json = JSON.parse(data);
            let msg = '登录异常';
            if (json.kick_out_type >>> 0 === 10) {
                msg = '用户在其他地方登录';
            } else if (json.kick_out_type >>> 0 === 20) {
                msg = '您已被踢出直播间';
            }
            if (this.DWLive) {
                this.destroyPlayer();
            }
            let duration = 3;
            const message = this.$message.error({
                message: `${msg}, ${duration}秒后关闭`,
                duration: 0,
                onClose: () => {
                    this.$store.dispatch('logout', true);
                }
            });
            const timer = setInterval(() => {
                duration -= 1;
                message.message = `${msg}, ${duration}秒后关闭`;
                if (duration === 0 && timer) {
                    message.close();
                    clearInterval(timer);
                }
            }, 1000);
        },
        /**
         * 禁言
         */
        handleBanChat(data) {
            console.log('禁言', data);
        },
        /**
         * 解除禁言
         */
        handleUnBanChat(data) {
            console.log('解除禁言', data);
        },
        /**
         * 禁言并删除聊天记录
         */
        handleBanDeleteChat(data) {
            console.log('禁言并删除聊天记录', data);
        },
        /**
         * 用户禁言后群发消息通知; data:回调数据
         */
        handleHDBanChatBroadcastWithData(data) {
            console.log('用户禁言后群发消息通知; data:回调数据', data);
        },
        /**
         * 在线人数
         */
        handleUserCountMessage(count) {
            this.onlineUserCount = count;
        },
        /**
         * 开始直播后显示公告
         */
        handleAnnouncementShow(e) {
            this.notice = e;
        },
        /**
         * 发布和修改公告
         */
        handleAnnouncementRelease(e) {
            this.notice = e;
        },
        /**
         * 删除公告
         */
        handleAnnouncementRemove(e) {
            this.notice = '';
        },
        /**
         * 收到私聊
         */
        handlePrivateChatMessage(e) {
            const message = JSON.parse(e);
            console.log('收到私聊', message);
            this.messageList.push(message);
        },
        /**
         * 收到私聊回复
         */
        handlePrivateAnswer(e) {
            const message = JSON.parse(e);
            console.log('收到私聊回复', message);
            this.messageList.push(message);
        },
        /**
         * 开始签到
         */
        handleStartRollCall(e) {
            console.log('开始签到', e);
        },
        /**
         * 开始抽奖
         */
        handleStartLottery(e) {
            console.log('开始抽奖', e);
        },
        /**
         * 中奖
         */
        handleWinLottery(e) {
            console.log('中奖', e);
        },
        /**
         * 结束抽奖
         */
        handleStopLottery(e) {
            console.log('结束抽奖', e);
        },
        /**
         * 开始答题（voteType:0/1; 0为单选题，1为多选题）
         */
        handleStartVote(e) {
            console.log('开始答题（voteType:0/1; 0为单选题，1为多选题）', e);
        },
        /**
         * 结束答题
         */
        handleStopVote(e) {
            console.log('结束答题', e);
        },
        /**
         * 答题统计
         */
        handleVoteResult(e) {
            console.log('答题统计', e);
        },
        /**
         * 讲师接受互动信息
         */
        handleCCLiveInteractionAccept(e) {
            console.log('讲师接受互动信息', e);
        },
        /**
         * 互动信息
         */
        handleCCLiveInteractionMessage(e) {
            console.log('互动信息', e);
        },
        /**
         * 已经在聊天的列表信息
         */
        handleCCLiveInteractionChatUsers(e) {
            console.log('已经在聊天的列表信息', e);
        },
        /**
         * 挂断互动信息
         */
        handleCCLiveInteractionDisconnect(e) {
            console.log('挂断互动信息', e);
        },
        /**
         * 是否显示在线人数（0为不显示，1为显示）
         */
        handleShowUserCount(e) {
            this.showOnlineUserCount = e >>> 0 === 1;
        },
        /**
         * 显示简介
         */
        handleLiveDesc(e) {
            console.log('显示简介', e);
        },
        /**
         * 广播消息回调
         */
        handleBroadcastMsg(e) {
            console.log('广播消息回调', e);
        },
        /**
         * 发布问卷
         */
        handleQuestionnairePublish(e) {
            console.log('发布问卷', e);
        },
        /**
         * 结束发布问卷
         */
        handleQuestionnairePublishStop(e) {
            console.log('结束发布问卷', e);
        },
        /**
         * 发布问卷统计
         */
        handleQuestionnairePublishStatis(e) {
            console.log('发布问卷统计', e);
        },
        /**
         * 第三方问卷调查
         */
        handleExternalQuestionnairePublish(e) {
            console.log('第三方问卷调查', e);
        },
        /**
         * 翻页信息回调
         */
        handlePageChange(e) {
            console.log('翻页信息回调', e);
        },
        /**
         * 修改用户昵称回调
         */
        handleChangeNickName(e) {
            console.log('修改用户昵称回调', e);
        },
        /**
         * 获取当前播放（数据源）场景
         */
        handleSwitchSource(e) {
            console.log('获取当前播放（数据源）场景', e);
        },
        /**
         * 随堂测发布消息回调; data:发送信息回调数据
         */
        handlePracticePublish(data) {
            console.log('随堂测发布消息回调; data:发送信息回调数据', data);
        },
        /**
         * 随堂测停止答题消息回调; data:回调数据
         */
        handlePracticePublishStop(data) {
            console.log('随堂测停止答题消息回调; data:回调数据', data);
        },
        /**
         * 关闭随堂测; data:回调数据
         */
        handlePracticeClose(data) {
            console.log('关闭随堂测; data:回调数据', data);
        },
        /**
         * 开启打卡功能; data:回调数据
         */
        handleHdLiveStartPunch(data) {
            console.log('开启打卡功能; data:回调数据', data);
        },
        /**
         * 停止打卡功能; data:回调数据
         */
        handleHdLiveStopPunch(data) {
            console.log('停止打卡功能; data:回调数据', data);
        },
        /**
         * 用户进出直播间消息通知; data:回调数据
         */
        handleHDUserRemindWithAction(data) {
            console.log('用户进出直播间消息通知; data:回调数据', data);
        },
        /**
         * socket链接成功回调
         */
        handleSocketConnect() {
            console.log('socket链接成功回调;');
        },
        /**
         * socket链接失败回调
         */
        handleSocketDisconnect(e) {
            console.log('socket链接失败回调;', e);
        }
    }
};
</script>

<style lang="scss" scoped>
.live-area {
    position: absolute;
    left: 310px;
    right: 310px;
    top: 0;
    bottom: 0;
}
.live-player {
    position: absolute;
    width: 100%;
    height: 100%;
    &-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 98;
    }
}
#livePlayer {
    height: 100%;
    width: 100%;
}
#drawPanel {
    width: 100%;
    height: 100%;
    position: absolute;
}
.live {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #30343f;
    overflow: hidden;
    &-notice {
        z-index: 999;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 44px;
        overflow: hidden;
        background: #ffffff27;
        &-content {
            position: absolute;
            white-space: nowrap;
            line-height: 44px;
            color: #eb4f4f;
            font-weight: 500;
            padding: 0 24px;
            right: 0;
            transform: translateX(100%);
            animation: slide-in 32s linear infinite;
        }
    }
    &-controls {
        z-index: 999;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 44px;
        overflow: hidden;
        &-bar {
            height: 44px;
            background: #27282a;
            opacity: 0.9;
            color: #ffffff;
            font-weight: 500;
            padding: 0 10px;
            transform: translateY(44px);
            transition: all 300ms ease-in;
        }
        &:hover {
            .live-controls-bar {
                transform: translateY(0) !important;
            }
        }
    }
    &-tip {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
        background-color: #30343f;
        &-img {
            width: 226px;
            height: 115px;
            object-fit: contain;
        }
        &-text {
            font-size: 32px;
            color: #ffffff;
            margin-top: 32px;
            text-align: center;
            // .small {
            //     font-size: 20px;
            // }
        }
    }
    &-aside {
        width: 310px;
        height: 100%;
        background-color: #333335;
    }
    &-intro {
        padding: 7px 15px 9px;
        color: #666666;
    }
    &-title {
        font-size: 18px;
        color: #ffffff;
        margin: 12px 0;
    }
    &-text {
        margin: 11px 0;
    }
    &-tools {
        height: calc(100vh - 373px);
        &::v-deep {
            .el-tabs__nav {
                width: 100%;
                // display: flex
            }
            .el-tabs__item {
                color: #707074;
                font-weight: 500;
                padding: 0;
            }
            .el-tabs__nav-wrap {
                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                }
                &::after,
                &::before {
                    height: 1px;
                    background: #545454;
                }
            }
            .el-tabs__active-bar {
                width: 3em !important;
                margin-left: calc(25% - 1.5em);
                height: 3px;
                background: #c1c1c2;
            }
            .el-tabs__content {
                flex: 1;
            }
        }
    }
}
.only-resource {
    &::v-deep {
        .el-tabs__active-bar {
            display: none;
            width: initial !important;
            margin-left: 0;
            height: 3px;
            background: transparent;
        }
    }
}
.tool-icon {
    cursor: pointer;
    width: 20px;
    height: 20px;
}
.tool-item {
    & + & {
        margin-left: 16px;
    }
}
.tab-panel {
    height: 100%;
}
.second-screen {
    width: 310px;
    height: 199px;
    background-color: #2b2b2d;
}
.tip {
    line-height: 39px;
    &-footer {
        margin-top: 20px;
        width: 260px;
    }
}
.time-label {
    padding: 4px 8px;
    background-color: rgb(126, 122, 122);
    border-radius: 4px;
    margin: 0 4px;
}
@keyframes slide-in {
    0% {
        right: 0;
        transform: translateX(100%);
    }

    100% {
        right: 100%;
        transform: translateX(0);
    }
}
</style>
